export const FIRESTORE_COLLECTIONS = {
  usuariosAdmin: 'USUARIOSADMIN'
} as const;

